import script from "./ProductCouleurLieeDelier.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCouleurLieeDelier.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__